import { render, staticRenderFns } from "./Greet.vue?vue&type=template&id=3309d50a&scoped=true&"
import script from "./Greet.vue?vue&type=script&lang=js&"
export * from "./Greet.vue?vue&type=script&lang=js&"
import style0 from "./Greet.vue?vue&type=style&index=0&id=3309d50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309d50a",
  null
  
)

export default component.exports